import { render, staticRenderFns } from "./AccountDashboard.vue?vue&type=template&id=20d55fe0&scoped=true&"
import script from "./AccountDashboard.vue?vue&type=script&lang=ts&"
export * from "./AccountDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./AccountDashboard.vue?vue&type=style&index=0&id=20d55fe0&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d55fe0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20d55fe0')) {
      api.createRecord('20d55fe0', component.options)
    } else {
      api.reload('20d55fe0', component.options)
    }
    module.hot.accept("./AccountDashboard.vue?vue&type=template&id=20d55fe0&scoped=true&", function () {
      api.rerender('20d55fe0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/accounts/accountDashboard/AccountDashboard.vue"
export default component.exports